import React from 'react';
import classnames from 'classnames';
import styles from './loading.module.scss';

const baseClass = 'loader';
export type LoaderProps = {
  hiddenLoadingStatus?: string;
  size?: 'large' | 'medium' | 'small' | 'extra-small';
  className?: string;
  messageId: string;
};

/**
 * Make your Loader Component accessible:
 * @param {hiddenLoadingStatus} hiddenLoadingStatus should change depending on the loading state.
 */

export const Loader: React.FC<LoaderProps> = ({ hiddenLoadingStatus, size = 'large', messageId, className }) => {
  const classes = classnames(styles[baseClass], styles[`${baseClass}--${size}`], className);

  return (
    <div
      className={classes}
      role="status"
      aria-live="polite"
      aria-label={hiddenLoadingStatus}
      data-testid="loading-component"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        className={styles[`${baseClass}__asset`]}
      >
        <g strokeWidth="8">
          <path d=" M 4 40 A 36 36 0 0 1 76 40" stroke="url(#half-circle-top)" />
          <path d=" M 76 40 A 36 36 180 0 1 4 40" stroke="url(#half-circle-bottom)" />
          <path d=" M 4 40 A 36 36 180 0 1 5 33" stroke="var(--ds-accent)" strokeLinecap="round" />
        </g>

        <defs>
          <linearGradient id="half-circle-top">
            <stop offset="0%" stopOpacity="0" stopColor="currentColor" />
            <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
          </linearGradient>
          <linearGradient id="half-circle-bottom">
            <stop offset="0%" stopOpacity="1" stopColor="currentColor" />
            <stop offset="100%" stopOpacity="0.5" stopColor="currentColor" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
